import { AppDetailViewModel, ClientDetailViewModel, ScopeDetailViewModel, TokenDetailViewModel } from "../actions";
import { CLEAR_LIST, LOGGED_OUT } from "./constants";
import { ClearListAction, LoggedOutAction } from "./types";

export const SET_TOKENS_LIST = "SET_TOKENS_LIST";
export const SET_APPS_LIST = "SET_APPS_LIST";
export const SET_CLIENTS_LIST = "SET_CLIENTS_LIST";
export const SET_SCOPES_LIST = "SET_SCOPES_LIST";
export const ADD_NEW_TOKEN = "ADD_NEW_TOKEN";
export const ADD_NEW_APP = "ADD_NEW_APP";
export const SET_HAS_WITHDRAW_REFUND = "SET_HAS_WITHDRAW_REFUND";

export interface ClientState {
  app: {
    list: AppDetailViewModel[];
    details?: AppDetailViewModel;
    totalCount: number;
  };
  client: {
    list: ClientDetailViewModel[];
    details?: ClientDetailViewModel;
    totalCount: number;
  };
  hasWithdrawRefund?: boolean;
  allScopes: {
    scopes: ScopeDetailViewModel[];
    identityScopes: ScopeDetailViewModel[];
  };
  token: {
    list: TokenDetailViewModel[];
    details?: TokenDetailViewModel;
    totalCount: number;
  };
}

export interface SetAppsListAction {
  type: typeof SET_APPS_LIST;
  payload: ClientState["app"];
}

export interface SetClientsListAction {
  type: typeof SET_CLIENTS_LIST;
  payload: ClientState["client"];
}

export interface SetTokensListAction {
  type: typeof SET_TOKENS_LIST;
  payload: ClientState["token"];
}

export interface SetScopesListAction {
  type: typeof SET_SCOPES_LIST;
  payload: { scopes: ScopeDetailViewModel[]; identityScopes: ScopeDetailViewModel[] };
}

export interface AddNewAppAction {
  type: typeof ADD_NEW_APP;
  payload: AppDetailViewModel;
}

export interface AddNewTokenAction {
  type: typeof ADD_NEW_TOKEN;
  payload: TokenDetailViewModel;
}

export type ClientActionTypes =
  | SetAppsListAction
  | SetClientsListAction
  | SetTokensListAction
  | SetScopesListAction
  | AddNewAppAction
  | AddNewTokenAction
  | ClearListAction
  | LoggedOutAction;

const initialState: ClientState = {
  allScopes: {
    identityScopes: [],
    scopes: [],
  },
  app: {
    list: [],
    totalCount: 0,
  },
  client: {
    list: [],
    totalCount: 0,
  },
  hasWithdrawRefund: false,
  token: {
    list: [],
    totalCount: 0,
  },
};

export default function client(state = initialState, action: ClientActionTypes): ClientState {
  if (action.type === SET_APPS_LIST) {
    const { list, totalCount } = action.payload;
    return {
      ...state,
      app: { list, totalCount },
    };
  }

  if (action.type === SET_CLIENTS_LIST) {
    const { list, totalCount } = action.payload;
    return {
      ...state,
      client: { list, totalCount },
    };
  }

  if (action.type === SET_TOKENS_LIST) {
    const { list, totalCount } = action.payload;
    return {
      ...state,
      token: { list, totalCount },
    };
  }

  if (action.type === SET_SCOPES_LIST) {
    return {
      ...state,
      allScopes: action.payload,
    };
  }

  if (action.type === ADD_NEW_TOKEN) {
    return {
      ...state,
      token: {
        list: [...state.token.list, action.payload],
        totalCount: state.token.totalCount && state.token.totalCount + 1,
      },
    };
  }

  if (action.type === ADD_NEW_APP) {
    return {
      ...state,
      app: {
        list: [...state.app.list, action.payload],
        totalCount: state.app.totalCount && state.app.totalCount + 1,
      },
    };
  }

  if (action.type === CLEAR_LIST) {
    return {
      ...state,
      app: { ...state.app, list: [], totalCount: 0 },
      client: { ...state.client, list: [], totalCount: 0 },
      token: { ...state.token, list: [], totalCount: 0 },
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  return state;
}
